module.exports = __webpack_public_path__ + "assets/img/ION Orchard.179c6d46.jpg";